// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2yEd-","tooltip":"GoDC_","tooltipIcon":"_5ffOv"};